export const iconFontAwesomeChildhoodChildren = (
	<i className="fa-solid fa-children"></i>
);
